import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";


// export const getProducts = async (id) => {
//   try {
//     return await getData(`/website/products/product`);
//   } catch (error) {
//     console.log(error);
//   }
// };



export const getProducts = async (category_id = "") => {
  try {
    let url = `/website/products/product`;

    if (category_id) {
      url += `?category_id=${category_id}`;
    }

    return await getData(url);
  } catch (error) {
    console.log(error);
  }
};


export const getProductById = async (id) => {
  try {
    return await getData(`/website/products/product/${id}`);
  } catch (error) {
    console.log(error);
  }
};